import React from 'react';
import PropTypes from 'prop-types';
import AlertDialogBase from './AlertDialogBase';

class AlertDialog extends React.Component {
  static propTypes = {
    cancelText: PropTypes.string.isRequired,
    className: PropTypes.string,
    onCancel: PropTypes.func,
    open: PropTypes.bool.isRequired,
    styleType: PropTypes.string,
  };
  static defaultProps = {
    styleType: 'default',
  };
  getStyles = type => {
    switch (type) {
      default:
        return {};
    }
  };
  render() {
    const { styleType, ...otherProps } = this.props;
    const styles = this.getStyles(styleType);

    return <AlertDialogBase styles={styles} {...otherProps} />;
  }
}

export default AlertDialog;
